import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { WEEKDAYS_SHORT, MONTHS, monthWeeks, sameDay, dateKey, addMonths, startOfDay } from '../../lib/calendar';

// Sol paneldeki küçük ay takvimi: seçili görünüm aralığı vurgulanır, etkinlikli günlerde nokta olur
export const MiniMonth = ({ cursor, rangeStart, rangeEnd, eventDays, onPick }) => {
  const [month, setMonth] = useState(new Date(cursor.getFullYear(), cursor.getMonth(), 1));
  useEffect(() => { setMonth(new Date(cursor.getFullYear(), cursor.getMonth(), 1)); }, [cursor]);
  const today = new Date();

  return (
    <div data-testid="mini-month">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold">{MONTHS[month.getMonth()]} {month.getFullYear()}</h3>
        <div className="flex">
          <button onClick={() => setMonth(addMonths(month, -1))} className="p-1 rounded hover:bg-secondary" aria-label="Önceki ay"><ChevronLeft className="h-4 w-4" /></button>
          <button onClick={() => setMonth(addMonths(month, 1))} className="p-1 rounded hover:bg-secondary" aria-label="Sonraki ay"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 text-center text-[11px] text-muted-foreground mb-1">
        {WEEKDAYS_SHORT.map((d) => <div key={d}>{d.charAt(0)}</div>)}
      </div>
      <div className="space-y-0.5">
        {monthWeeks(month).map((week) => (
          <div key={dateKey(week[0])} className="grid grid-cols-7">
            {week.map((day) => {
              const inRange = Boolean(rangeStart) && day >= startOfDay(rangeStart) && day < rangeEnd;
              const isToday = sameDay(day, today);
              return (
                <button
                  key={dateKey(day)}
                  onClick={() => onPick(day)}
                  className={`relative h-8 text-xs flex items-center justify-center transition-colors ${
                    isToday ? 'rounded-full bg-primary text-primary-foreground font-semibold'
                      : inRange ? 'bg-accent text-accent-foreground' : 'hover:bg-secondary rounded-full'
                  } ${day.getMonth() !== month.getMonth() && !isToday ? 'text-muted-foreground/60' : ''}`}
                  aria-label={day.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                  data-testid={`mini-day-${dateKey(day)}`}
                >
                  {day.getDate()}
                  {eventDays.has(dateKey(day)) && !isToday && <span className="absolute bottom-0.5 h-1 w-1 rounded-full bg-primary" />}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniMonth;
